module.exports = __webpack_public_path__ + "static/media/settingsStar.c4e2938b.svg";